import { Gallery, Item } from 'react-photoswipe-gallery';
import { PreviewItem } from '../commetFileModal';

export function PreviewGallery({ items }: { items: PreviewItem[] }) {
  if (!items.length) return null;
  return (
    <Gallery withCaption>
      <div className="d-flex flex-wrap gap-2">
        {items.map((p, idx) => (
          <figure key={`${p.url}-${idx}`} className="m-0 position-relative">
            <Item original={p.url} width={p.w ?? 1600} height={p.h ?? 1200} caption={p.name}>
              {({ ref, open }: any) => (
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    open();
                  }}
                >
                  <img
                    ref={ref as React.Ref<HTMLImageElement>}
                    src={p.url}
                    alt={p.name ?? 'preview'}
                    style={{
                      width: 60,
                      height: 60,
                      objectFit: 'cover',
                      borderRadius: 6,
                      display: 'block',
                    }}
                  />
                </a>
              )}
            </Item>
          </figure>
        ))}
      </div>
    </Gallery>
  );
}
